export default "__VITE_ASSET__cbf1083b__"